import useSWR, { SWRResponse } from "swr";

import { useAuthErrorHandler } from "../common/hooks";
import {
    BankAccount,
    BeneficiaryDetails,
    ContactResponse,
    X500Name,
} from "../types/common";

import request, { ApiError } from "./common";

const utilitiesApi = {
    partyInfo: (party: X500Name): Promise<ContactResponse> => {
        return request<ContactResponse>(`common/party-info/${party}`);
    },

    partyInfos: (partys: X500Name[]): Promise<ContactResponse[]> => {
        return request<ContactResponse[], X500Name[]>(`common/party-infos`, "POST", partys);
    },

    partyInfoByAccount: (account: string): Promise<ContactResponse> => {
        return request<ContactResponse>(`common/account-info/${account}`);
    },

    partyInfosByAccount: (accounts: string[]): Promise<ContactResponse[]> => {
        return request<ContactResponse[], string[]>(`common/account-infos`, "POST", accounts);
    },
};

export const useContractorList = (): SWRResponse<
    PartyResponsePayload[],
    ApiError
> => {
    const onError = useAuthErrorHandler();
    return useSWR<PartyResponsePayload[], ApiError>(
        "/common/main-contractor-accounts",
        request,
        { onError },
    );
};

export const useContractorAccountList = (
    userProfileId: string,
): SWRResponse<
    PartyResponsePayload[],
    ApiError
> => {
    const onError = useAuthErrorHandler();
    return useSWR<PartyResponsePayload[], ApiError>(
        `/common/main-contractors-account/${userProfileId}`,
        request,
        { onError },
    );
};

export const useContractorBankAccountList = (): SWRResponse<
    BeneficiaryDetails[],
    ApiError
> => {
    const onError = useAuthErrorHandler();
    return useSWR<BeneficiaryDetails[], ApiError>(
        "/common/contractor/bank-account",
        request,
        { onError },
    );
};

export const useDeveloperBankAccountList = (
    userProfileId: string,
): SWRResponse<
    BankAccount[],
    ApiError
> => {
    const onError = useAuthErrorHandler();
    return useSWR<BankAccount[], ApiError>(`/bankacct/bank-account?userProfileId=${userProfileId}`, request, {
        onError,
    });
};

export type PartyResponsePayload = {
    name: X500Name;
    party: X500Name;
    accountName: string;
};

export type PartyInfoRequest = {
    partyList: X500Name[]
}

export type AccountInfoRequest = {
    accountList: string[]
}

export default utilitiesApi;
